module.exports = __webpack_public_path__ + "static/media/default-featured-banner.96bf05a0.jpg";